import { render, staticRenderFns } from "./CheckListProtocolosSitioArqueologico.vue?vue&type=template&id=68433332&"
import script from "./CheckListProtocolosSitioArqueologico.vue?vue&type=script&lang=js&"
export * from "./CheckListProtocolosSitioArqueologico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports